<template>
    <div class="row">
        <div class="col-lg-12">
            <OrderStatusMainInformationCard v-if="orderStatus" :order-status="orderStatus" @update:orderStatus="orderStatus = $event" />
        </div>
        <div class="col-lg-12">
            <NavTab class="nav-tabs-bottom">
                <NavTabItem key="#orders" href="#" :active="$route.name === 'OrdersStatusOrderTable'" @click="changePage('OrdersStatusOrderTable')">
                    <i class="icon-cart mr-2"></i>
                    {{ $t('sidebar.items.orders') }}
                </NavTabItem>
                <NavTabItem key="#sms-templates" href="#" :active="$route.name === 'OrderStatusSmsTemplates'" @click="changePage('OrderStatusSmsTemplates')">
                    <i class="icon-bubble mr-2"></i>
                    {{ $t('sidebar.items.smsTemplates') }}
                </NavTabItem>
            </NavTab>
            <router-view v-slot="{ Component }">
                <component
                    v-if="orderStatus"
                    :is="Component"
                    :order-status="orderStatus"
                >
                </component>
            </router-view>
        </div>
    </div>
</template>
<script>
import OrderStatusMainInformationCard from "./cards/MainInformationCard.vue";
import NavTab from "../../../components/tabs/NavTab.vue";
import NavTabItem from "../../../components/tabs/NavTabItem.vue";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: "OrderStatusEditPage",
    components: {
        OrderStatusMainInformationCard, NavTab, NavTabItem
    },
    data() {
        return {
            orderStatus: null
        }
    },
    methods: {
        changePage(pageName) {
            this.$router.push({name: pageName})
        }
    },
    mounted() {
        this.orderStatus = this.$store.getters['route/crmOrderStatus']
    }
}
</script>